import { AfterViewInit, Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import {ToolsService} from '../../services/tools/tools.service';
import {Utilisateur} from '../../../interface/api/Utilisateur';
import {ResearchService} from '../../services/tools/research.service';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {Mandat} from '../../../class/api/Mandat';
import {ExComissionMandat} from '../../../class/ex/ex-comission-mandat';
import {LocalStorage} from 'ngx-webstorage';
import {Subscription} from 'rxjs';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-mandats',
    templateUrl: './mandats.component.html',
    styleUrls: ['./mandats.component.scss'],
    providers: [ResearchService],
    imports: [MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, DatePipe, TranslateModule]
})
export class MandatsComponent implements OnInit, AfterViewInit {
    toolService = inject(ToolsService);
    translateService = inject(TranslateService);

    private subscriptions: Subscription[] = [];
    profil: Utilisateur = null;
    @Input() simpleDisplay = false;

    @Input('profil') set field(profil: Utilisateur) {
        this.profil = profil;
        this.mandats.data = new HydraCollection({
            'hydra:member': this.profil.mandats,
        }).getMember();

    }

    user: Utilisateur = null;

    @LocalStorage() public dateShort; // FR de base
    public MATERIAL_COLUMNS = ['commission.commissionType.label', 'commission.label', 'mandatType.label',
        'dateDebut', 'dateFin', 'statut'];
    public mandats = new MatTableDataSource<Mandat>([]);
    @ViewChild(MatSort, {static: false}) sort: MatSort;


    constructor() {
        this.getTranslations();
    }

    private rolePresident = 'front.mandat.rolePresident';
    private roleMembre = 'front.mandat.roleMembre';
    private roleVicePresident = 'front.mandat.roleVicePresident';
    private statutEnCours = 'front.mandat.statutEnCours';
    private statutTermine = 'front.mandat.statutTermine';
    private statutAVenir = 'front.mandat.statutAVenir';


    public getTranslations() {
        this.subscriptions.push(this.translateService.get(this.rolePresident).subscribe(res => this.rolePresident = res));
        this.subscriptions.push(this.translateService.get(this.roleMembre).subscribe(res => this.roleMembre = res));
        this.subscriptions.push(this.translateService.get(this.roleVicePresident).subscribe(res => this.roleVicePresident = res));
        this.subscriptions.push(this.translateService.get(this.statutEnCours).subscribe(res => this.statutEnCours = res));
        this.subscriptions.push(this.translateService.get(this.statutTermine).subscribe(res => this.statutTermine = res));
        this.subscriptions.push(this.translateService.get(this.statutAVenir).subscribe(res => this.statutAVenir = res));
    }

    ngOnInit() {}

    ngAfterViewInit() {
        this.mandats.sort = this.sort;
    }

    public getStatus(item: Mandat) {
        const statut = new ExComissionMandat(item).getStatus();
        switch (statut.label) {
            case 'À venir' :
                return this.statutAVenir;
            case 'En cours' :
                return this.statutEnCours;
            case 'Terminé' :
                return this.statutTermine;
        }
    }

    public roleLabel(role) {
        switch (role) {
            case 'Président' :
                return this.rolePresident;
            case 'Membre' :
                return this.roleMembre;
            case 'Vice-président' :
                return this.roleVicePresident;
        }
    }

    changeSort(event) {
        if (!event.active || event.direction === '') {
            return;
        }
        this.mandats.data.sort((a, b) => {
            const isAsc = event.direction === 'asc';
            switch (event.active) {
                case 'commission.commissionType.label': return this.toolService.compareForSorting(a.commission.commissionType.label, b.commission.commissionType.label, isAsc);
                case 'commission.label': return this.toolService.compareForSorting(a.commission.label, b.commission.label, isAsc);
                case 'mandatType.label': return this.toolService.compareForSorting(a.mandatType.label, b.mandatType.label, isAsc);
                default: return 0;
            }
        });
    }
}
